/**
 * Watch2Gether — synchronised video watch-party extension
 *
 * Declares two web-accessible resources, `javascript/adapter/w2g_netflix_adapter.js`
 * and `controls.html`, matched to `<all_urls>` with no `use_dynamic_url`. Both are
 * served at a fixed URL to any page. The `w2g_`-namespaced adapter script is a
 * vendor-specific path, making the fetch conclusive when it succeeds.
 *
 * Manifest verified against version 10.6.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'cimpffimgeipdhnhjohpbehjkcdpjolg';

export const watch2gether: ExtensionDefinition = {
  id: ID,
  name: 'Watch2Gether',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 900_000,
  notes:
    'Two static WAR on <all_urls> with no dynamic URL, including the w2g_-namespaced ' +
    'Netflix adapter script. Detection is a single fetch and conclusive.',
  signals: [
    {
      id: 'war-netflix-adapter-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch javascript/adapter/w2g_netflix_adapter.js — a w2g_-namespaced adapter ' +
        'script exposed to every origin. The prefix makes the path distinctive to W2G.',
      weight: 1,
      run: () => probeFetch(ID, 'javascript/adapter/w2g_netflix_adapter.js'),
    },
    {
      id: 'war-controls-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch controls.html — the second static entry point exposed to <all_urls>, an ' +
        'independent corroborating path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'controls.html'),
    },
  ],
};
